import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SlimHeader from './SlimHeader';
import FooterNav from './FooterNav';

const AppLayout: React.FC = () => {
  const location = useLocation();

  // Determine path display based on current route
  const getPagePath = () => {
    const path = location.pathname;
    if (path === '/resume') return '/resume/';
    if (path === '/') return '/root/';
    return path.endsWith('/') ? path : `${path}/`;
  };

  return (
    <div className="app-layout">
      {/* Unified Slim Header */}
      <SlimHeader pagePath={getPagePath()} />

      {/* Main Content Area */}
      <main className="app-main" style={{ paddingTop: '48px', paddingBottom: '68px' }}>
        <div className="container">
          <Outlet />
        </div>
      </main>

      {/* Unified Footer Navigation */}
      <FooterNav navigationMode />
    </div>
  );
};

export default AppLayout;
